import React from "react";

/**
 * TransparentButton
 * - Transparent background button with rounded corners and subtle border.
 * - Matches the app's glassmorphism theme.
 *
 * Props:
 * - children: ReactNode
 * - icon?: ReactNode // optional icon to display before text
 * - onClick?: () => void
 * - type?: "button" | "submit" | "reset"
 * - className?: string // extra class names to append
 * - radius?: number // borderRadius in px (default 12)
 * - style?: React.CSSProperties // inline style overrides/extends
 */
export default function TransparentButton({
  children,
  icon,
  onClick,
  type = "button",
  className = "",
  radius = 12,
  style = {},
}) {
  const mergedStyle = { borderRadius: radius, ...style };
  return (
    <button
      type={type}
      onClick={onClick}
      className={`btn-transparent ${className}`.trim()}
      style={mergedStyle}
    >
      {icon && <span className="btn-icon">{icon}</span>}
      {children && <span className="btn-text">{children}</span>}
    </button>
  );
}
